<script setup lang="ts">
// Bouton « Nouvelle inscription » rendu sous « Se connecter » (via le point
// d'injection Fondation « loginExtra », voir main.ts).
//
// Le clic n'entraîne AUCUN changement de page et n'ouvre pas d'overlay : il
// active le « mode étendu » de l'écran de connexion Fondation, ce qui fait
// rétrécir le col image de gauche et affiche le formulaire d'inscription dans
// les 3/4 droite (composant fourni via provide('loginExpandedComponent')).
//
// Le bouton ne s'affiche QUE si le formulaire d'admission dédié existe
// (realm/slug « Admission »/« admission ») : l'endpoint public de schéma renvoie
// 404 sinon. Ainsi l'inscription n'est proposée que lorsqu'un formulaire nommé
// spécifiquement pour cela est présent.
import { ref, onMounted } from 'vue';
import { getCustomSdk } from '@/sdk';
import { loginExpanded } from '@/composables/useLoginInscription';

const sdk = getCustomSdk();
const available = ref(false);

onMounted(async () => {
  try {
    const schema = await sdk.getPublicAdmissionSchema();
    available.value = Array.isArray(schema?.pages) && schema.pages.length > 0;
  } catch {
    available.value = false; // formulaire absent (404) → pas d'inscription
  }
});
</script>

<template>
  <div v-if="available" class="inscription-login-wrapper">
    <div class="inscription-login-sep"><span>ou</span></div>
    <button type="button" class="inscription-login-btn" @click="loginExpanded = true">
      <span class="ilb-plus" aria-hidden="true">+</span>
      <span>Nouvelle inscription</span>
    </button>
  </div>
</template>

<style scoped>
.inscription-login-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 18px;
}
.inscription-login-sep {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 180px;
  max-width: 60vw;
  margin-bottom: 16px;
  color: rgba(0, 0, 0, 0.4);
  font-size: 13px;
}
.inscription-login-sep::before,
.inscription-login-sep::after {
  content: '';
  flex: 1;
  height: 1px;
  background: rgba(0, 0, 0, 0.12);
}
.inscription-login-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 22px;
  border: 1.5px solid #3460a8;
  border-radius: 999px;
  background: transparent;
  color: #3460a8;
  font-family: 'Public Sans', system-ui, -apple-system, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.inscription-login-btn:hover {
  background: #3460a8;
  color: #fff;
}
.ilb-plus {
  font-size: 17px;
  font-weight: 700;
  line-height: 1;
}
</style>
